// Import style lib
import styled from 'styled-components';

// Import colors
import colors from '../../utils/styles/colors';

// Styled page wrapper
export const StatisticsWrapper = styled.main`
    /* Appearance */
    background-color: ${colors.primaryBeige};

    /* Element disposition */
    flex-grow: 1;

    /* Content disposition */
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;

    /* Spacing */
    padding: 50px;

    /* Mobile setup */
    @media (max-width: 600px) {
        gap: 10px;

        padding: 10px;
    }
`;

// Styled chart section
export const ChartSection = styled.section`
    /* Appearance */
    background-color: white;
    border-radius: 10px;

    /* Content disposition */
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;

    /* Size */
    width: 90%;
    max-width: 1200px;

    /* Spacing */
    padding: 50px;

    /* Visual effects */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.5);

    /* Mobile setup */
    @media (max-width: 600px) {
        width: 90vw;
        gap: 7px;

        padding: 15px 0px;
    }
`;

// Styled chart title
export const ChartTitle = styled.h1`
    /* Spacing */
    margin-bottom: 30px;
`;
